import { useRef, useEffect } from 'react';
import LocomotiveScroll from 'locomotive-scroll';
import { useLocation } from 'react-router-dom';

const useScroll = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  useEffect(() => {
    const imagesLoaded = require('imagesloaded');
    const images = document.querySelectorAll('img');
    const scroll = new LocomotiveScroll({
      el: scrollRef.current as HTMLElement | undefined,
      smooth: true,
      smartphone: {
        smooth: true,
      },
      tablet: {
        smooth: true,
        breakpoint: 700,
      },
    });
    imagesLoaded(images, () => {
      scroll.update();
    });
    return () => {
      scroll.destroy();
    };
  }, [location]);

  return { scrollRef };
};

export { useScroll };
